var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipseBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1021,
    height: 875,
    viewBox: "0 0 1021 875",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.3 2C61.314 94.1133 3 222.49 3 364.486C3 644.778 230.215 872 510.5 872C790.785 872 1018 644.778 1018 364.486C1018 222.74 959.891 94.5654 866.196 2.48685",
    stroke: "white",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseBig);
export default __webpack_public_path__ + "static/media/ellipse_big.80b6c81f257883d649413afc248c261c.svg";
export { ForwardRef as ReactComponent };